import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";

const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@CrossBorder/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useCrossBorderCampaignRouterMap = () => {
  const { t } = useTranslation();

  return [
    {
      path: "/Non_order",
      element: LazyLoad("Quotation/index.tsx"),
      name: t("routes.inquiryManagement"),
      key: "AddToShoppingListKey",
      icon: "AddToShoppingList",
    },
    {
      path: "/Non_order/creativeInquiry/:productId",
      element: LazyLoad("Quotation/creativeInquiry"),
      name: t("routes.fillInquiry"),
      editName: t("routes.editInquiry"),
      key: "AdCreative",
      isHidden: true,
      fromPath: "/Non_order",
      pathReg: /\/Non_order\/productId\/\d+/,
    },
    {
      path: "/Non_order/editInquiry/:inquiryId/:productId",
      element: LazyLoad("Quotation/creativeInquiry"),
      name: t("routes.editInquiry"),
      key: "EditAdCreative",
      editName: t("routes.editInquiry"),
      isHidden: true,
      fromPath: "/Non_order",
      pathReg: /\/Non_order\/editInquiry\/\d+\/\d+/,
    },
    {
      path: "/Non_order/inquirydetails/:status/:inquiryId/:productId",
      element: LazyLoad("Quotation/inquirydetailed"),
      name: t("routes.inquiryDetails"),
      key: "inquirydetails",
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/Non_order\/inquirydetails\/\d+\/\d+/,
    },
    {
      path: "/Non_order/details/:status/:inquiryId/:productId",
      element: LazyLoad("Quotation/detailedInformation"),
      name: t("routes.orderDetails"),
      key: "details",
      isHidden: true,
      fromPath: "/order",
      pathReg: /\/Non_order\/details\/\d+\/\d+/,
    },
    {
      path: "/Non_ExtensionManagement",
      element: LazyLoad("Campaign/index.tsx"),
      name: t("routes.campaignManagement"),
      key: "tggl",
      icon: "Megaphone",
    },
    {
      path: "/Non_ExtensionManagement/importCampaign",
      element: LazyLoad("Campaign/importAdCreative"),
      name: t("routes.importMaterial"),
      key: "importCampaign",
      icon: "importCampaign",
      isHidden: true,
      fromPath: "/Non_ExtensionManagement",
    }
  ];
};

export const CrossBorderCampaignRouterMap: routeConfig[] = [
  {
    path: "/Non_order",
    element: LazyLoad("Quotation/index.tsx"),
    name: "询价管理",
    key: "AddToShoppingListKey",
    icon: "AddToShoppingList",
  },
  {
    path: "/Non_order/creativeInquiry/:productId",
    element: LazyLoad("Quotation/creativeInquiry"),
    name: "填写询单",
    editName: "编辑填写询单",
    key: "AdCreative",
    isHidden: true,
    fromPath: "/Non_order",
    pathReg: /\/Non_order\/productId\/\d+/,
  },
  {
    path: "/Non_order/editInquiry/:inquiryId/:productId",
    element: LazyLoad("Quotation/creativeInquiry"),
    name: "编辑填写询单",
    key: "EditAdCreative",
    editName: "编辑填写询单",
    isHidden: true,
    fromPath: "/Non_order",
    pathReg: /\/Non_order\/editInquiry\/\d+\/\d+/,
  },
  {
    path: "/Non_order/inquirydetails/:status/:inquiryId/:productId",
    element: LazyLoad("Quotation/inquirydetailed"),
    name: "询单详情",
    key: "inquirydetails",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/Non_order\/inquirydetails\/\d+\/\d+/,
  },
  {
    path: "/Non_order/details/:status/:inquiryId/:productId",
    element: LazyLoad("Quotation/detailedInformation"),
    name: "订单详情",
    key: "details",
    isHidden: true,
    fromPath: "/order",
    pathReg: /\/Non_order\/details\/\d+\/\d+/,
  },
  {
    path: "/Non_ExtensionManagement",
    element: LazyLoad("Campaign/index.tsx"),
    name: "推广管理",
    key: "tggl",
    icon: "Megaphone",
  },
  {
    path: "/Non_ExtensionManagement/importCampaign",
    element: LazyLoad("Campaign/importAdCreative"),
    name: "导入物料",
    key: "importCampaign",
    icon: "importCampaign",
    isHidden: true,
    fromPath: "/Non_ExtensionManagement",
  }
];
